import { createSlice } from '@reduxjs/toolkit';
import { getPartnerInfo } from '../../utils/partnerInfo';

const initialState = {
    isLoggedIn: !!(sessionStorage.getItem('partner-t') || localStorage.getItem('partner-t')),
    partnerInfo: getPartnerInfo(),
    partnerType: sessionStorage.getItem('partner-type') || localStorage.getItem('partner-type') || null,
    token: (sessionStorage.getItem('partner-t') || localStorage.getItem('partner-t')) || null,
}

export const partnerSlice = createSlice({
    name: 'partner',
    initialState,
    reducers: {
        LOGIN: (state, action) => {
            state.isLoggedIn = true;
            state.partnerInfo = action.payload.partnerInfo;
            state.partnerType = action.payload.partnerType;
            state.token = action.payload.accessToken;
        },
        LOGOUT: (state) => {
            state.isLoggedIn = false;
            state.partnerInfo = null;
            state.partnerType = null;
            state.token = null;
            sessionStorage.removeItem('partner-t');
            sessionStorage.removeItem('partner-info');
            sessionStorage.removeItem('partner-type');
            localStorage.removeItem('partner-t');
            localStorage.removeItem('partner-info');
            localStorage.removeItem('partner-type');
        },
        UPDATE_PARTNER_INFO: (state, action) => {
            state.partnerInfo = action.payload;
        },
    },
})

export const { LOGIN, LOGOUT, UPDATE_PARTNER_INFO } = partnerSlice.actions

export default partnerSlice.reducer
